'use client';
import { isObject } from '@s7/utils';
import { computeCoordsFromPlacement } from './computeCoordsFromPlacement.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var computePosition = /*#__PURE__*/ _async_to_generator(function(reference, floating, config) {
    var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware_i, name, fn, _ref, nextX, nextY, data, reset, _obj, _tmp, ref;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _config_placement = config.placement, placement = _config_placement === void 0 ? "bottom" : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? "absolute" : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                validMiddleware = middleware.filter(Boolean);
                return [
                    4,
                    platform.isRTL == null ? void 0 : platform.isRTL.call(platform, floating)
                ];
            case 1:
                rtl = _state.sent();
                return [
                    4,
                    platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    })
                ];
            case 2:
                rects = _state.sent();
                _computeCoordsFromPlacement = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                statefulPlacement = placement;
                middlewareData = {};
                resetCount = 0;
                i = 0;
                _state.label = 3;
            case 3:
                if (!(i < validMiddleware.length)) return [
                    3,
                    11
                ];
                _validMiddleware_i = validMiddleware[i], name = _validMiddleware_i.name, fn = _validMiddleware_i.fn;
                return [
                    4,
                    fn({
                        x: x,
                        y: y,
                        initialPlacement: placement,
                        placement: statefulPlacement,
                        strategy: strategy,
                        middlewareData: middlewareData,
                        rects: rects,
                        platform: platform,
                        elements: {
                            reference: reference,
                            floating: floating
                        }
                    })
                ];
            case 4:
                _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                x = nextX != null ? nextX : x;
                y = nextY != null ? nextY : y;
                middlewareData = _extends({}, middlewareData, (_obj = {}, _obj[name] = _extends({}, middlewareData[name], data), _obj));
                if (!(reset && resetCount <= 50)) return [
                    3,
                    10
                ];
                resetCount++;
                if (!isObject(reset)) return [
                    3,
                    9
                ];
                if (reset.placement) {
                    statefulPlacement = reset.placement;
                }
                if (!reset.rects) return [
                    3,
                    8
                ];
                if (!(reset.rects === true)) return [
                    3,
                    6
                ];
                return [
                    4,
                    platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    })
                ];
            case 5:
                _tmp = _state.sent();
                return [
                    3,
                    7
                ];
            case 6:
                _tmp = reset.rects;
                _state.label = 7;
            case 7:
                rects = _tmp;
                _state.label = 8;
            case 8:
                ref = computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y;
                _state.label = 9;
            case 9:
                i = -1;
                return [
                    3,
                    10
                ];
            case 10:
                i++;
                return [
                    3,
                    3
                ];
            case 11:
                return [
                    2,
                    {
                        x: x,
                        y: y,
                        placement: statefulPlacement,
                        strategy: strategy,
                        middlewareData: middlewareData
                    }
                ];
        }
    });
});

export { computePosition };
